export const formatDate = (dateString) => {
  const dateObj = new Date(dateString);
  const day = String(dateObj.getUTCDate()).padStart(2, '0');
  const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
  const year = dateObj.getUTCFullYear();
  return `${day}-${month}-${year}`;
};


export function formatTime(utcString) {
  const date = new Date(utcString);
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const formattedMinutes = minutes.toString().padStart(2, "0");
  return `${hours}:${formattedMinutes} ${period}`;
}

export const getLocation = () =>
  new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(null);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
        });
      },
      (error) => {
        console.log("Location denied/error", error);
        resolve(null); // ❗ login fail nahi hoga
      }
    );
  });

export const convertMs = (ms) => {
  const hours = Math.floor(ms / (1000 * 60 * 60));
  const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor(ms / 1000) % 60;

  return { hours, minutes, seconds };
};

export const getCurrentServerTime = (lastServerTime,lastClientSyncTime) => {
  if (!lastServerTime || !lastClientSyncTime) {
    return null;
  }
  const elapsed = Date.now() - lastClientSyncTime;

  return new Date(lastServerTime.getTime() + elapsed);
};

// Makes sections[].sectionTime sum to exactly the endTime-startTime window,
// so the section timer never runs out before header's clock does. Called
// at login and again on "Start Exam", since endTime can change between them.
export const reconcileSectionsToWindow = (sections, startTimeStr, endTimeStr) => {
  if (!Array.isArray(sections) || sections.length === 0) return sections;
  const timeToMinutes = (time) => {
    const [hh, mm] = time.split(":").map(Number);
    return hh * 60 + mm;
  };
  const minutesToTime = (minutes) => {
    const hh = Math.floor(minutes / 60).toString().padStart(2, "0");
    const mm = (minutes % 60).toString().padStart(2, "0");
    return `${hh}:${mm}`;
  };
  const start = new Date(startTimeStr);
  const end = new Date(endTimeStr);
  // Round up — sections only store whole minutes, and a few extra seconds
  // is safer than coming up short.
  const targetMinutes = Math.ceil((end.getTime() - start.getTime()) / (60 * 1000));
  const totalTimeAllocated = sections.reduce(
    (sum, sec) => sum + timeToMinutes(sec.sectionTime),
    0
  );
  if (totalTimeAllocated === 0) {
    return sections;
  }
  let timeDiff = totalTimeAllocated - targetMinutes;
  if (timeDiff > 0) {
    // Too much — shrink starting from the first section.
    for (let i = 0; i < sections.length && timeDiff > 0; i++) {
      let sectionMinutes = timeToMinutes(sections[i].sectionTime);
      if (sectionMinutes > 0) {
        const reduceBy = Math.min(timeDiff, sectionMinutes);
        sectionMinutes -= reduceBy;
        sections[i].sectionTime = minutesToTime(sectionMinutes);
        timeDiff -= reduceBy;
      }
    }
  } else if (timeDiff < 0) {
    // Too little — grow the last section to cover the shortfall.
    const shortfall = -timeDiff;
    const lastIndex = sections.length - 1;
    const lastSectionMinutes = timeToMinutes(sections[lastIndex].sectionTime);
    sections[lastIndex].sectionTime = minutesToTime(lastSectionMinutes + shortfall);
  }
  return sections;
};